<template>
  <div>
    <div v-if="error">
      <server-error :error="error" />
    </div>
    <div>
      <h2 class="mb-4">{{reportTypeName}}</h2>
      <div class="b-reports__header-info mb-6">
        <div class="row b-reports__header-row mb-2">
          <div class="col-2">
            <div class="b-reports__name mb-1">{{$t('CONTENT.contract.lessee')}}</div>
            <div class="b-reports__value">
              {{getCounterpartyName(filterWithoutContract.lessee)}}
              <div class="b-contract__check mx-1" v-if="checkIsCounterpartyIntragroup(filterWithoutContract.lessee)">
                <dynamic-icon class="mr-2" icon="check"></dynamic-icon>
              </div>
            </div>
          </div>
        </div>
        <div class="row b-reports__header-row">
          <div class="col-2">
            <div class="b-reports__name mb-1">{{$t('CONTENT.reportPage.reports_period')}}</div>
            <div class="b-reports__value">{{filterWithoutContract.periodStartDate | dateFormatted}} <span v-if="filterWithoutContract.periodEndDate">- {{filterWithoutContract.periodEndDate | dateFormatted}}</span></div>
          </div>

          <div class="col-2">
            <div class="b-reports__name mb-1">{{$t('CONTENT.reportPage.report_date')}}</div>
            <div class="b-reports__value">{{new Date | dateFormatted}}</div>
          </div>
          <div class="col-2">
            <div class="b-reports__name mb-1">{{$tc('CONTENT.currency.currency_code', 1)}}</div>
            <div class="b-reports__value">{{currencyCode}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import dateConverter from "../../../utils/converters/date.converter";

export default {
  props: {
    filterWithoutContract: {
      type: Object,
    },
    reportTypeName: {
      type: String,
    }
  },
  data() {
    return {
      error: null,
    };
  },
  computed: {
    ...mapGetters(['getContractSettings']),
    ...mapGetters(['allCounterparties']),
    currencyCode() {
      return this.getContractSettings.currencyCode;
    }
  },
  methods: {
    getCounterpartyName(lesseeId) {
      for (let i = 0; i < this.allCounterparties.length; i++) {
        if(this.allCounterparties[i].idInDB === lesseeId) {
          return this.allCounterparties[i].displayName;
        }
      }
    },
    checkIsCounterpartyIntragroup(counterpartyId) {
      for (let i = 0; i < this.allCounterparties.length; i++) {
        if (this.allCounterparties[i].idInDB === counterpartyId) {
          return this.allCounterparties[i].isIntragroupTurnover;
        }
      }
    },
  }
};
</script>
